import {
  PROMOTER_CHAT_WIDGET_DIAGNOSTIC_LOG,
  PROMOTER_CHAT_WIDGET_DIAGNOSTIC_RUN_TESTS,
} from '@mm/api-routes';
import {
  ChatWidgetDiagnosticResult,
  ChatWidgetTroubleshootingToolIssueType,
} from '../interfaces/chatWidgetTroubleshooting';
import AuthenticatedController from './AuthenticatedController';

export class ChatWidgetTroubleshootingController extends AuthenticatedController {
  static postLog(
    url: string,
    fbPageId: string,
    issueType: ChatWidgetTroubleshootingToolIssueType,
    botId: number,
    promoterId: number,
    result: ChatWidgetDiagnosticResult,
  ) {
    return super.post(PROMOTER_CHAT_WIDGET_DIAGNOSTIC_LOG(botId, promoterId), {
      site_url: url,
      remote_page_id: fbPageId,
      issue_type: issueType,
      result,
    });
  }
  static runTests(botId: number, promoterId: number) {
    return super.post(
      PROMOTER_CHAT_WIDGET_DIAGNOSTIC_RUN_TESTS(botId, promoterId),
    );
  }
}
